/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { ShaftType } from "@/constants/enums/Enums";
import { httpV2 } from "@/api/index";
import {
	GET_GEARBOX_STAGE_2_RESULT,
	GET_GEARBOX_STAGE_2_RESULT_SUCCESS,
	GET_GEARBOX_STAGE_2_RESULT_ERROR,
	RESET_GEARBOX_STAGE_2_RESULT,
} from "@/stores/actions/WindDiagnosticGearboxStageTwoBrokenTeethResult";

const state = {
	status: FetchStatus.Init,
	data:   {
		imsData: 0,
		lssData: 0,
	},
	error: {},
};

const actions = {
	[GET_GEARBOX_STAGE_2_RESULT]: async({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_STAGE_2_RESULT);

		try
		{
			const [ ims, lss ] = await Promise.all([
				httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/${ShaftType.IMS}/GearboxStage2BrokenTeeth`),
				httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/${ShaftType.LSS}/GearboxStage2BrokenTeeth`)
			]);

			commit(GET_GEARBOX_STAGE_2_RESULT_SUCCESS, { imsData: ims.data, lssData: lss.data });
		}
		catch (error)
		{
			commit(GET_GEARBOX_STAGE_2_RESULT_ERROR, error.response);
		}
	},
	[RESET_GEARBOX_STAGE_2_RESULT]: ({ commit }) =>
	{
		commit(RESET_GEARBOX_STAGE_2_RESULT);
	},
};

const mutations = {
	[GET_GEARBOX_STAGE_2_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_STAGE_2_RESULT_SUCCESS]: (state, { imsData, lssData }) =>
	{
		state.status = FetchStatus.Loaded;
		state.data.imsData = imsData;
		state.data.lssData = lssData;
	},
	[GET_GEARBOX_STAGE_2_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_GEARBOX_STAGE_2_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.data.imsData = null;
		state.data.lssData = null;
	},
};

export default {
	state,
	actions,
	mutations,
};
